import { render, staticRenderFns } from "./CourseModal.vue?vue&type=template&id=7fd77d40&scoped=true&"
import script from "./CourseModal.vue?vue&type=script&lang=ts&"
export * from "./CourseModal.vue?vue&type=script&lang=ts&"
import style0 from "./CourseModal.vue?vue&type=style&index=0&id=7fd77d40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd77d40",
  null
  
)

export default component.exports